import { all, call, fork, put, takeEvery, delay } from "redux-saga/effects";
import { LOGIN_USER, REGISTER_USER, LOGOUT_USER } from "../actions";

import {
  loginUserSuccess,
  loginUserError,
  registerUserSuccess,
  registerUserError,
} from "./actions";
import axios from "axios";
import { END_POINT } from "../../constants/defaultValues";
import { getOrGenerateDeviceUUID } from "../../helpers/Device";
import {
  buildStoredAuthPayload,
  createAuthHandoffUrl,
} from "../../helpers/AuthHandoff";

const loginWithEmailPasswordAsync = async (username, password, domain) => {
  const device_uuid = getOrGenerateDeviceUUID();
  try {
    return await axios.post(END_POINT + "/auth/signin", {
      username,
      password,
      domain,
      device_uuid,
    });
  } catch (err) {
    return (
      err.response || {
        status: 500,
        data: { responseText: err.message || "Lỗi đăng nhập" },
      }
    );
  }
};

function* loginWithEmailPassword({ payload }) {
  const { username, password, domain, baseDomain } = payload.user;
  // const { history } = payload;

  try {
    const loginUser = yield call(
      loginWithEmailPasswordAsync,
      username,
      password,
      domain,
    );

    if (loginUser && loginUser.status === 200) {
      localStorage.setItem("user_id", loginUser.data.user.id);
      localStorage.setItem("b", loginUser.data.user.idParent);
      localStorage.setItem("access_token", loginUser.data.token);
      if (loginUser.data.user && loginUser.data.user.device_uuid) {
        localStorage.setItem("vmass_device_uuid", loginUser.data.user.device_uuid);
      }
      localStorage.setItem("username", loginUser.data.user.username);
      localStorage.setItem("avatar", loginUser.data.user.image);
      localStorage.setItem("companyUUID", loginUser.data.user.companyUUID);
      localStorage.setItem(
        "companyAddress",
        loginUser.data.user.companyAddress,
      );
      localStorage.setItem("companyName", loginUser.data.user.companyName);
      localStorage.setItem("companyImage", loginUser.data.user.companyImage);
      localStorage.setItem(
        "companyWebsite",
        loginUser.data.user.companyWebsite,
      );
      localStorage.setItem("companyLogo", loginUser.data.user.companyLogo);
      // Thêm lưu thông tin cho in hóa đơn
      localStorage.setItem(
        "fullname",
        loginUser.data.user.fullname || loginUser.data.user.username,
      );
      localStorage.setItem("hotline", loginUser.data.user.hotline || "");
      localStorage.setItem("namePay", loginUser.data.user.namePay || "");
      localStorage.setItem("numberPay", loginUser.data.user.numberPay || "");
      localStorage.setItem("bankPay", loginUser.data.user.bankPay || "");
      localStorage.setItem(
        "businessType",
        loginUser.data.user.businessType || "",
      );
      localStorage.setItem(
        "admin",
        loginUser.data.user.admin ? "true" : "false",
      );
      // Save domain for Electron & Web
      const resolvedDomain =
        (loginUser.data.user && loginUser.data.user.domain) || domain || "";
      if (resolvedDomain) {
        localStorage.setItem("vmass_store_domain", resolvedDomain);
        localStorage.setItem("domain", resolvedDomain);
      }
      if (loginUser.data.user) {
        localStorage.setItem("user", JSON.stringify(loginUser.data.user));
      }

      // Set session cookie for Super Admin (vmass) only
      if (loginUser.data.user.username === "vmass") {
        document.cookie = "admin_session=true; path=/";
      }
      localStorage.setItem(
        "roleSettings",
        JSON.stringify(loginUser.data.roleSettings),
      );

      yield put(loginUserSuccess(loginUser));

      const protocol = window.location.protocol; // Lấy giao thức (http: hoặc https:)
      let targetPath = "/app/pages/analytics";

      if (loginUser.data.isCashier) {
        targetPath = "/cashier/default";
      } else if (loginUser.data.isPaymenter) {
        targetPath = "/payment/default";
      } else if (loginUser.data.isKitchen) {
        targetPath = "/kitchen/default";
      } else if (loginUser.data.user.username === "vmass") {
        targetPath = "/root/upgrade/dashboards";
      }

      // Xây dựng URL đầy đủ mới
      // Nếu `baseDomain` được truyền vào (trường hợp đăng ký) thì mới chuyển hướng
      if (baseDomain) {
        const targetUrl = `${protocol}//${domain}.${baseDomain}${targetPath}`;
        try {
          const newUrl = yield call(
            createAuthHandoffUrl,
            targetUrl,
            buildStoredAuthPayload(),
          );
          // Thực hiện chuyển hướng toàn trang
          window.location.href = newUrl;
        } catch (handoffErr) {
          console.warn("Handoff creation failed, redirecting directly:", handoffErr);
          window.location.href = targetUrl;
        }
      } else {
        // Nếu không có baseDomain (trường hợp đăng nhập thông thường), dùng history.push như cũ
        const { history } = payload;
        if (history && history.push) {
          history.push(targetPath);
        } else {
          window.location.href = targetPath;
        }
      }
    } else {
      const errorPayload = loginUser || {
        status: 500,
        data: { responseText: "Đăng nhập không thành công" },
      };
      yield put(loginUserError(errorPayload));
    }
  } catch (error) {
    const errorPayload = error?.response || {
      status: 500,
      data: {
        responseText: error?.message || "Lỗi kết nối máy chủ",
      },
    };
    yield put(loginUserError(errorPayload));
    console.log("login error : ", error);
  }
}

const registerWithEmailPasswordAsync = async (
  phone,
  password,
  fullname,
  businessType,
  domain,
  url,
  email,
) => {
  const device_uuid = getOrGenerateDeviceUUID();
  try {
    return await axios.post(END_POINT + "/auth/signup", {
      phone,
      password,
      fullname,
      businessType,
      domain,
      url,
      email,
      device_uuid,
    });
  } catch (err) {
    return (
      err.response || {
        status: 500,
        data: { responseText: err.message || "Lỗi đăng ký" },
      }
    );
  }
};

function* registerWithEmailPassword({ payload }) {
  // Thêm history vào destructuring
  const { history } = payload;
  const { phone, fullname, businessType, password, domain, url, email } =
    payload.user;
  try {
    const registerUser = yield call(
      registerWithEmailPasswordAsync,
      phone,
      password,
      fullname,
      businessType,
      domain,
      url,
      email,
    );

    if (registerUser && registerUser.status === 200) {
      // 1. Dispatch action báo đăng ký thành công
      yield put(registerUserSuccess(registerUser));

      if (registerUser.data.user && registerUser.data.user.device_uuid) {
        localStorage.setItem("vmass_device_uuid", registerUser.data.user.device_uuid);
      }

      // Check if there's a pending upgrade from price.vmass.vn
      const pendingUpgrade = localStorage.getItem("pendingUpgrade");

      // DEBUG: Log full response to check what backend returns
      console.log("[DEBUG] registerUser.data:", registerUser.data);
      console.log(
        "[DEBUG] registerUser.data.token exists:",
        !!registerUser.data.token,
      );
      console.log("[DEBUG] registerUser.data.user:", registerUser.data.user);
      console.log("[DEBUG] pendingUpgrade:", pendingUpgrade);

      if (pendingUpgrade) {
        // Save auth data to localStorage for payment page to use
        // Save ALL fields that login saves to maintain consistency
        const user = registerUser.data.user;

        console.log("[DEBUG] User object:", user);
        console.log("[DEBUG] user.id:", user?.id);
        console.log("[DEBUG] user.idParent:", user?.idParent);

        if (registerUser.data.token) {
          localStorage.setItem("access_token", registerUser.data.token);
          console.log("[DEBUG] Saved access_token");
        } else {
          console.error("[ERROR] No token in response!");
        }
        if (user) {
          // Core fields
          localStorage.setItem("user_id", user.id);
          localStorage.setItem("b", user.idParent);
          localStorage.setItem("username", user.username);
          localStorage.setItem("companyUUID", user.companyUUID);
          console.log(
            "[DEBUG] Saved core fields: user_id=",
            user.id,
            ", b=",
            user.idParent,
          );

          // Display fields
          localStorage.setItem("fullname", user.fullname || user.username);
          localStorage.setItem("companyName", user.companyName || "");
          localStorage.setItem("businessType", user.businessType || "");

          // Avatar and images
          localStorage.setItem("avatar", user.image || "");
          localStorage.setItem("companyImage", user.companyImage || "");
          localStorage.setItem("companyLogo", user.companyLogo || "");

          // Contact info
          localStorage.setItem("companyAddress", user.companyAddress || "");
          localStorage.setItem("companyWebsite", user.companyWebsite || "");
          localStorage.setItem("hotline", user.hotline || "");

          // Payment info
          localStorage.setItem("namePay", user.namePay || "");
          localStorage.setItem("numberPay", user.numberPay || "");
          localStorage.setItem("bankPay", user.bankPay || "");

          // Admin flag
          localStorage.setItem("admin", user.admin ? "true" : "false");

          // Domain for Electron & Web
          if (user.domain) {
            localStorage.setItem("vmass_store_domain", user.domain);
            localStorage.setItem("domain", user.domain);
          }
          localStorage.setItem("user", JSON.stringify(user));
        }

        // 2. Đợi 3 giây để người dùng xem modal thành công
        yield delay(3000);

        // 3. Redirect đến trang payment thay vì auto-login
        window.location.href = "/user/payment";
        return;
      }

      // Normal flow: không có pending upgrade
      // 2. Đợi 5 giây để người dùng xem modal thành công với countdown
      yield delay(5000);

      // 3. Tự động đăng nhập người dùng
      // Dùng `put` để gọi một action khác, ở đây là LOGIN_USER
      yield put({
        type: LOGIN_USER,
        payload: {
          user: {
            username: domain,
            password: password,
            domain: domain,
            baseDomain: url,
          },
          history: history, // Truyền history để saga login có thể chuyển hướng
        },
      });
    } else {
      const errorPayload = registerUser || {
        status: 500,
        data: {
          responseText: "Đăng ký không thành công",
        },
      };
      yield put(registerUserError(errorPayload));
    }
  } catch (error) {
    const errorPayload = error?.response || {
      status: 500,
      data: {
        responseText: error?.message || "Lỗi kết nối máy chủ",
      },
    };
    yield put(registerUserError(errorPayload));
    console.log("register error : ", error);
  }
}

function logout({ payload }) {
  const { history } = payload;
  try {
    localStorage.removeItem("user_id");
    localStorage.removeItem("b");
    localStorage.removeItem("access_token");
    localStorage.removeItem("username");
    localStorage.removeItem("avatar");
    localStorage.removeItem("companyUUID");
    localStorage.removeItem("companyAddress");
    localStorage.removeItem("companyName");
    localStorage.removeItem("companyImage");
    localStorage.removeItem("companyWebsite");
    localStorage.removeItem("companyLogo");
    localStorage.removeItem("businessType");
    localStorage.removeItem("admin");
    localStorage.removeItem("roleSettings");

    // Clear admin session cookie
    document.cookie =
      "admin_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    if (history && history.push) {
      history.push("/");
    } else {
      window.location.href = "/";
    }
  } catch (error) {
    console.error(error);
  }
}

export function* watchRegisterUser() {
  yield takeEvery(REGISTER_USER, registerWithEmailPassword);
}

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchRegisterUser),
  ]);
}
